import {gsap, smoother, ScrollTrigger} from "../Utility/gsap";
import Dom from '../utility/dom';

export const InitBackgroundTransitions = () => {
  const els = document.querySelectorAll('.has_transition_background');
  
  if(els){
    els.forEach((el, index) => {
      const theme = el.getAttribute('data-theme');

      if(theme){
        const prevEl = el.previousElementSibling;
        ScrollTrigger.create({
          trigger: el,
          start: `top center`,
          end: `bottom center`,
          onEnter: () => {
            Dom.body.setAttribute('data-theme', theme);
          },
          onEnterBack: () => {
            Dom.body.setAttribute('data-theme', theme);
          },
          onLeaveBack: () => {
            if(index == 0){
              const origTheme = Dom.body.getAttribute('data-page-theme');
              const setTheme = origTheme ? origTheme : 'cream';
              Dom.body.setAttribute('data-theme', setTheme);
            }
            else if(!prevEl.classList.contains('has_transition_background')){
              const prevTheme = els[index-1].getAttribute('data-theme');
              if(prevTheme){
                Dom.body.setAttribute('data-theme', prevTheme);
              }
            }
          }
        });
      }
    });
  };
}
